import type { OnboardingModalProps } from '@app/types/modal';
import Onboarding from '@component/Onboarding';

export const OnboardingModal = ({ closeModal }: OnboardingModalProps) => {
  return <Onboarding onClose={closeModal} />;
};
